import ActressCard from '@/components/base/ActressCard';
import { getFeaturedActresses } from '@/mocks/actresses';

export default function FeaturedActresses() {
  const featured = getFeaturedActresses();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-medium mb-4">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-[10px]"></i>
            </div>
            精选推荐
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            推荐女优
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            精选当下最热门的日本女优，包含详细资料与代表作品
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {featured.map((actress) => (
            <ActressCard key={actress.id} actress={actress} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}